/**
 * `2026-10-11` → `11/10/2026`. FECHA CIVIL, SIN ZONA HORARIA.
 *
 * PARTIDO A MANO Y NO CON `Date`, y eso es lo importante. `new
 * Date('2026-10-11')` se interpreta como medianoche UTC: en Costa Rica —seis
 * horas atrás— eso es el 10 de octubre a las 6 de la tarde, así que una fecha
 * límite escrita «11» se mostraría «10» a todo el mundo. Un día antes, en la
 * pantalla que dice hasta cuándo hay para jugar.
 *
 * Y EN ESTE FORMATO Y NO EN EL DEL SISTEMA: `toLocaleDateString()` da
 * «10/11/2026» en inglés de Estados Unidos, que acá se lee como el 10 de
 * noviembre. Un torneo en Grecia lo lee gente de Grecia.
 *
 * VIVE ACÁ PORQUE ESTABA ESCRITA DOS VECES, idéntica, en el cuadro y en el
 * muro; la tercera copia iba a ser esta. Dos copias de una regla de fechas es
 * cómo una pantalla muestra el día correcto y la de al lado no.
 */
export function formatDay(iso: string): string {
  const [year, month, day] = iso.split('-');
  return year === undefined || month === undefined || day === undefined
    ? iso
    : `${day}/${month}/${year}`;
}
